import { sendRequestWithAuth } from '../common/sendRequest';
import * as settings from './settings';

export function getDeviceFeatures() {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_device_features',
      })
    }
  );
}



// WEBPACK FOOTER //
// ./src/services/deviceFeatures.js